import React from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../../components/shared/PrivateRoute';
import DashboardLayout from '../../layouts/DashoardLayout';
import { Box, Paper } from '../../ui/core';
import { flushPageSx, surfaceCardSx } from '../../ui/styles';
import FleetVehiclesTable from './FleetVehiclesTable';

const FleetManagementShell = () => (
  <Box sx={flushPageSx}>
    <Paper elevation={0} sx={{ ...surfaceCardSx, flex: 1, minWidth: 0 }}>
      <Switch>
        <PrivateRoute exact path="/fleet-management" component={FleetVehiclesTable} />
      </Switch>
    </Paper>
  </Box>
);

const FleetManagement = () => (
  <DashboardLayout flush title="Fleet Management">
    <FleetManagementShell />
  </DashboardLayout>
);

export default FleetManagement;
